import { i18n } from 'next-i18next'
import { FlowStep } from '../../flow-types'
import { Config } from 'modules/config/state/config-types'
import { INITIAL_INVALID_STEP_INDEX, INITIAL_NUM_VISITS } from './constants'

export const OPTIONS_STEP_NAME = 'options'

const makeOptionsStep = (config: Config): FlowStep => {
  const t = i18n?.t.bind(i18n) || ((key: string, fallback: string) => fallback)

  const enabled =
    config.dcf.isEnabled ||
    !config.designation.isOptional ||
    !config.dedication.isOptional ||
    !config.doubleTheDonation.isOptional ||
    !config.comment.isOptional

  return {
    name: OPTIONS_STEP_NAME,
    title: t('DonationOptionsStep.title', 'Donation options'),
    enabled,
    index: INITIAL_INVALID_STEP_INDEX,
    numVisits: INITIAL_NUM_VISITS,
    layout: 'flow-two-column',
  }
}

export default makeOptionsStep
